export default __webpack_public_path__ + "static/media/internal-direction.15471c16.svg";